import { useTheme } from '@chakra-ui/react';
import { css, Global } from '@emotion/react/macro';
import { FC } from 'react';
import { rgba } from 'polished';
import { cofo, antique } from './fonts';
import { rem } from 'utils/fonts';

const GlobalStyles: FC = () => {
  const { colors } = useTheme();

  return (
    <Global
      styles={css`
        @font-face {
          font-family: 'antique';
          src: url('/fonts/antique/antiqueolitot_med.woff2') format('woff2'), url('/fonts/antique/antiqueolitot_med.woff') format('woff');
          font-weight: bold;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'antique';
          src: url('/fonts/antique/antiqueolitot_reg.woff2') format('woff2'), url('/fonts/antique/antiqueolitot_reg.woff') format('woff');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'cofo';
          src: url('/fonts/cofo/CoFo_Sans-Bold.woff2') format('woff2'), url('/fonts/cofo/CoFo_Sans-Bold.woff') format('woff');
          font-weight: bold;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'cofo';
          src: url('/fonts/cofo/CoFo_Sans-Medium.woff2') format('woff2'), url('/fonts/cofo/CoFo_Sans-Medium.woff') format('woff');
          font-weight: 500;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'cofo';
          src: url('/fonts/cofo/CoFo_Sans-Regular.woff2') format('woff2'), url('/fonts/cofo/CoFo_Sans-Regular.woff') format('woff');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          background: ${colors.blue[400]};
          font-family: ${cofo};
        }

        .chooose-onboarding.shepherd-element.shepherd-enabled {
          .shepherd-header {
            background-color: transparent;
            padding: 30px 25px 0 77px;

            .shepherd-title {
              font-weight: bold;
              font-size: ${rem(18)};
              line-height: ${rem(29)};
              font-family: ${antique};
              color: ${colors.gray[900]};
              margin-bottom: 10px;
              position: relative;
            }

            .onboarding_title.onboarding_title--trimmed {
              max-width: 200px;
            }

            .onboarding_tile {
              content: '';
              background: ${rgba(colors.pink[500], 0.2)};
              position: absolute;
              width: 40px;
              height: 40px;
              left: -57px;
              top: 3px;
              border-radius: 8px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .onboarding_tile.onboarding_tile--no-bg {
              background: none;
            }

            .onboarding_tile .oversized-image {
              width: 250%;
              max-width: none;
              transform: translate(-20%, 30%);
            }

            .onboarding_tile path {
              fill: ${colors.other.CTA};
            }

            .onboarding_counter {
              display: inline-block;
              margin-left: 5px;
              font-weight: 500;
              font-size: ${rem(18)};
              line-height: ${rem(29)};
              font-family: ${cofo};
              color: ${rgba(colors.gray[900], 0.33)};
            }
          }

          &[data-popper-placement^='left'] > .shepherd-arrow,
          &[data-popper-placement^='right'] > .shepherd-arrow {
            transform: translateY(-11px) !important;
            top: 50% !important;
          }

          .shepherd-arrow {
            &::before {
              background-color: ${colors.white} !important;
            }
          }

          .shepherd-content {
            border-radius: 9px;
          }

          .shepherd-text {
            font-weight: 500;
            font-size: ${rem(14)};
            font-family: ${cofo};
            color: ${rgba(colors.gray[900], 0.7)};
            line-height: 150%;
            padding: 0 25px 0 77px;
          }

          .shepherd-footer {
            margin-top: 15px;
            padding: 0 10px 10px 10px;

            .shepherd-button-secondary {
              font-family: ${cofo};
              font-size: ${rem(15)};
              font-weight: 600;
              margin-right: auto;
              text-transform: uppercase;
              background: transparent;
              color: ${rgba(colors.gray[900], 0.5)};
              padding: 5px 15px;

              &:hover {
                background: ${rgba(colors.gray[900], 0.1)};
              }
            }

            .shepherd-button-primary {
              font-family: ${cofo};
              font-size: ${rem(15)};
              font-weight: 600;
              text-transform: uppercase;
              background: transparent;
              color: ${rgba(colors.gray[900], 0.5)};
              padding: 5px 15px;

              span {
                display: inline-block;
                font-size: ${rem(20)};
                padding-right: 3px;
              }

              &:hover {
                background: ${rgba(colors.gray[900], 0.1)};
              }

              &:last-of-type {
                color: ${colors.pink[500]};

                span {
                  font-size: ${rem(20)};
                  padding: 0 0 0 3px;
                }
              }
            }
          }
        }
      `}
    />
  );
};

export default GlobalStyles;
